export interface Certification {
  title: string;
  institute: string;
  issued: string;
  link: string;
}

export const certificates: Certification[] = [
  {
    title: "Front-End Web Development with React",
    institute: "Coursera",
    issued: "Issued Apr 2020",
    link: "https://www.coursera.org/account/accomplishments/verify/56HLWX9TFCQ4",
  },
  {
    title: "Server-side Development with NodeJS, Express and MongoDB",
    institute: "Coursera",
    issued: "Issued Apr 2020",
    link: "https://www.coursera.org/account/accomplishments/verify/SQRURVBLXFMR",
  },
  {
    title: "Front-End JavaScript Frameworks: Angular",
    institute: "Coursera",
    issued: "Issued Jan 2020",
    link: "https://www.coursera.org/account/accomplishments/verify/DM24VHQGFXUE",
  },
  {
    title: "Front-End Web UI Frameworks and Tools: Bootstrap 4",
    institute: "Coursera",
    issued: "Issued Dec 2019",
    link: "https://www.coursera.org/account/accomplishments/verify/CD9BVSLD9G5W",
  },
  {
    title: "HTML, CSS, and Javascript for Web Developers",
    institute: "Coursera",
    issued: "Issued Nov 2019",
    link: "https://www.coursera.org/account/accomplishments/verify/KYAAD2CPAVQF",
  },
  {
    title: "Machine Learning",
    institute: "Coursera",
    issued: "Issued Nov 2019",
    link: "https://www.coursera.org/account/accomplishments/verify/ERPZXG5LAFNM",
  },
];
